<template>
  <!-- 企业服务-其他服务-知识产权服务 -->
  <div class="Invoice-body">
    <!-- 筛选 -->
    <el-form
      :model="screenData"
      :inline="true"
      class="screen"
      @submit.native.prevent="handelSearch"
    >
      <el-form-item label="订单ID：">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.orderNumber" placeholder="请输入订单ID"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="服务类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.Category" placeholder="请选择服务类型">
      <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="服务类别：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.Business" placeholder="请选择服务类别">
      <el-option
      v-for="item in optionsBusiness"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="企业类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.PayTaxes" placeholder="请选择企业类型">
      <el-option
      v-for="item in enterpriseBusiness"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="企业名称：">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.input" placeholder="请输入企业名称"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="统一社会信用代码：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.code" placeholder="请输入统一社会信用代码"></el-input>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" class="user-Id">
      <el-date-picker
      v-model="screenData.value"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="screenData.value = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
    <!--  -->
    <div class="table-top-Controls">
      <div class="RemainingLocation">
        <el-button type="primary" class="action-btn firm-clickable" @click="handelUp">提交多项</el-button>
        <el-button type="primary" class="action-btn firm-clickable" @click="handelAndLeProcess">提交一项</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="Table">
      <Table
        :tableData="tableData"
        :pagingObj="pagingObj"
        @handelDetails="handelDetails"
        @handelAndLeProcess="handelAndLeProcess"
        @handelEvaluation="handelEvaluation"
        @Refresh="Refresh"
      ></Table>
    </div>
    <!-- 底部分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <!-- 上传 -->
    <UpEstablishment
      :options1="options1"
      :enterprise="enterprise"
      :VisibleUp="VisibleUp"
      @handleCloseUp="VisibleUp = false"
      @handleSuccess="handleSuccess"
    ></UpEstablishment>
    <!-- 办理 -->
    <HandlePro
      :options1="options1"
      :enterprise="enterprise"
      :BusinessArr="BusinessArr"
      :RenewalArr="RenewalArr"
      :ApplicationArr="ApplicationArr"
      :VisibleHandlePro="VisibleHandlePro"
      @handleCloseHandlePro="VisibleHandlePro = false"
      @handleSuccess="handleSuccess"
    ></HandlePro>
    <!-- 详情/退款 -->
    <ReOfDe
      :VisibleDeRe="VisibleDeRe"
      :DeRe="DeRe"
      :row="row"
      :createTime="createTime"
      @handleCloseDeRe="VisibleDeRe = false"
      @handleConfirmDeRe="handleConfirmDeRe"
    ></ReOfDe>
    <!-- 服务评价弹窗 -->
    <EvaluationDialog
      :VisibleEvaluation="VisibleEvaluation"
      :orderNumber="orderNumber"
      :handleTypeName="handleTypeName"
      :businessTypeName="businessTypeName"
      :evaluatedName="evaluatedName"
      @handleCloseEvaluation="handleCloseEvaluation"
      @handleSuccess="handleEvaluationSuccess"
    ></EvaluationDialog>
  </div>
</template>

<script>
import {
  listIpr, //知识产权服务服务客户列表
  getIprInfo, //详情
  companySelectCustomers, //查询客户列表(客户下拉选择)
} from "../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
import UpEstablishment from "./components/Property/UpEstablishment.vue"; // 上传
import HandlePro from "./components/Property/HandlePro.vue"; // 办理
import ReOfDe from "./components/Property/NewDetails.vue"; // 详情/退款
import Table from "./components/Property/Table.vue";
import EvaluationDialog from "../../components/EvaluationDialog.vue"; //服务评价弹框
// 引入分页组件
import paging from "../../../../../../components/paging.vue";
export default {
  data() {
    return {
      screenData: {
        value: null, // 时间
        Category: "", //办理类别
        Business: "", //服务类型
        PayTaxes: "", //纳税类别
        input: "", //企业名称
        code: "", //信用代码
        orderNumber:'',//订单id
      },
      options: [
        { label: "申请", value: "0" },
        { label: "展期", value: "1" },
      ], //服务类型
      optionsBusiness: [
        { label: "商标", value: "0" },
        { label: "著作权", value: "1" },
        { label: "专利", value: "2" },
      ], //服务类别
      enterpriseBusiness: [
        { label: "有限公司", value: "0" },
        { label: "个体户", value: "1" },
        { label: "子公司", value: "2" },
        { label: "分公司", value: "3" },
        { label: "其它", value: "4" },
      ], //企业类型
      tableData: [],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      VisibleUp: false, //注销上传
      VisibleHandlePro: false, //办理
      DeRe: 0, // 0查看  1退款
      Distinguish: 0, //区分什么服务 0注销企业 1注销-银行开户  2注销开户-其他开户
      VisibleDeRe: false, //查看/退款
      VisibleEvaluation: false, //服务评价弹窗
      evaluatedName: "", // 被评价人
      orderNumber: "", //订单号
      handleTypeName: "", //服务类型
      businessTypeName: "", //服务类别
      options1: [], //平台企业的客户
      enterprise: {}, //平台企业的信息

      BusinessArr: [
        {
          id: 0,
          name: "申请",
          ShowHide: false, //后台控制是否显示

          code: ["11020401", "22020401"],
        },
        {
          id: 1,
          name: "展期",
          ShowHide: false, //后台控制是否显示

          code: ["11020402", "22020402"],
        },
      ], //
      ApplicationArr: [
        {
          id: 0,
          name: "商标",
          ShowHide: false, //后台控制是否显示

          code: ["1102040101", "2202040101"],
        },
        {
          id: 1,
          name: "著作权",
          ShowHide: false, //后台控制是否显示

          code: ["1102040102", "2202040102"],
        },
        {
          id: 2,
          name: "专利",
          ShowHide: false, //后台控制是否显示

          code: ["1102040103", "2202040103"],
        },
      ], //申请选择数据
      RenewalArr: [
        {
          id: 0,
          name: "商标",
          ShowHide: false, //后台控制是否显示

          code: ["1102040201", "2202040201"],
        },
        {
          id: 1,
          name: "专利",
          ShowHide: false, //后台控制是否显示

          code: ["1102040202", "2202040202"],
        },
      ], //展期选择数据

      row: {}, //被操作项的数据
      createTime:'',//订单时间
    };
  },
  watch: {},
  components: {
    paging,
    Table,
    UpEstablishment, //上传
    HandlePro, //办理
    ReOfDe,
    EvaluationDialog, //服务评价弹框
  },
  created() {
    this.$tool
      .CompanyPageMenu("110204")
      .then((res) => {
        // ====================== 统一规范重写开始 ======================
        // 1. 构建顶层code映射表
        const codeStatusMap = Object.fromEntries(
          res.map((item) => [item.code, item.onOrOff])
        );

        // 2. 处理 BusinessArr（申请/展期）
        this.BusinessArr.forEach((item) => {
          item.ShowHide = item.code.some(
            (code) => codeStatusMap[code] === true
          );
        });

        // 3. 找到申请、展期节点
        const applyNode = res.find(
          (item) => item.code === "11020401" || item.code === "22020401"
        );
        const renewalNode = res.find(
          (item) => item.code === "11020402" || item.code === "22020402"
        );

        // 4. 处理 ApplicationArr（申请子项）
        if (applyNode?.children) {
          const childMap = Object.fromEntries(
            applyNode.children.map((c) => [c.code, c.onOrOff])
          );
          this.ApplicationArr.forEach((item) => {
            item.ShowHide = item.code.some((code) => childMap[code] === true);
          });
        }

        // 5. 处理 RenewalArr（展期子项）
        if (renewalNode?.children) {
          const childMap = Object.fromEntries(
            renewalNode.children.map((c) => [c.code, c.onOrOff])
          );
          this.RenewalArr.forEach((item) => {
            item.ShowHide = item.code.some((code) => childMap[code] === true);
          });
        }
        // ====================== 统一规范重写结束 ======================
      });

    this.listIpr();
    this.companySelectCustomers();
  },
  destroyed() {},
  methods: {
    Refresh() {
      this.listIpr();
    },
    //付款成功
    handleSuccess() {
      this.VisibleUp = false;
      this.VisibleHandlePro = false;
      this.listIpr();
    },
    //查询客户列表(客户下拉选择)
    companySelectCustomers() {
      if (!this.$checkActionIpu()) return;
      API.companySelectCustomers().then((res) => {
        this.enterprise = res.data.self;
        var arr = res.data.customers;
        arr.unshift(res.data.self);
        this.options1 = arr;
      });
    },

    // 知识产权服务服务客户列表
    listIpr() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          operationType: this.screenData.Category, //服务类型
          iprType: this.screenData.Business, //服务类别
          orderCompanyType: this.screenData.PayTaxes, //orderCompanyType
          orderCompanyName: this.screenData.input, //企业名称
          orderCreditCode: this.screenData.code, // 统一代码
          startTime: time,
          endTime: timeEnd,
          orderNumber:this.screenData.orderNumber,//订单id
        },
      };
      API.listIpr(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    //重置
    handelReset() {
      this.pagingObj.currentPage = 1;
      this.screenData = {
        value: null, // 时间
        Category: "", //办理类别
        Business: "", //服务类型
        PayTaxes: "", //纳税类别
        input: "", //企业名称
        code: "", //信用代码
        orderNumber:'',//
      };
      this.listIpr(); // 查询分页列表
    },
    //搜索
    handelSearch() {
      this.pagingObj.currentPage = 1;
      this.listIpr(); // 查询分页列表
    },
    // 列表退款弹窗确认
    handleConfirmDeRe(textarea) {
      this.$tool
        .Refund(
          "/global/proxy/iprRequestRefund",
          this.row.orderNumber,
          textarea
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.listIpr();
          }
        });
      this.VisibleDeRe = false;
    },
    // 列表点击详情/退款
    handelDetails(num, row) {
      this.createTime = row.createTime
      var data = {
        data: {
          recordId: row.id,
        },
      };
      API.getIprInfo(data).then((res) => {
        this.row = res.data;
      });
      // num 0查看 1退款
      this.DeRe = num;
      if (num == 1) {
        if (!this.$checkAction()) return;
        this.VisibleDeRe = true;
      } else {
        this.VisibleDeRe = true;
      }
    },
    // 上传设立确定
    handleConfirmUp() {
      this.VisibleUp = false;
    },
    // 上传设立
    handelUp() {
      if (!this.$checkAction()) return;
      this.VisibleUp = true;
    },
    // 办理弹窗确认
    handleVHandlePro() {
      this.VisibleHandlePro = false;
    },
    // 办理
    handelAndLeProcess(num, row) {
      if (!this.$checkAction()) return;
      // 0办理  1重新提交
      this.VisibleHandlePro = true;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.listIpr(); // 查询分页列表
    },
    // 服务评价
    handelEvaluation(row) {
      if (!this.$checkAction()) return;
      this.orderNumber = row.orderNumber;
      this.handleTypeName = "知识产权服务"; // 知识产权服务服务的服务类型固定为"知识产权服务"
      this.businessTypeName = row.iprTypeName + (row.operationTypeName );
      this.evaluatedName = (row.evaluatedName || row.beEvaluatedName || row.handlerName || row.staffName || "");
      this.VisibleEvaluation = true;
    },
    // 关闭服务评价弹框
    handleCloseEvaluation() {
      this.VisibleEvaluation = false;
    },
    // 服务评价成功
    handleEvaluationSuccess() {
      this.listIpr();
    },
  },
};
</script>

<style scoped lang="less">
.Invoice-body {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  // 筛选
  .screen {
    margin-top: 10px;
    margin-bottom: 0;
    position: relative;
  }
// 表上方的操作项
  .table-top-Controls {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    align-items: center;
    .action-btn {
      width: 100px;
      height: 35px;
      background: #409eff !important;
      border-color: #409eff !important;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff !important;
      border: none;
      font-family: inherit;
      padding: 0 !important;
      line-height: 1 !important;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .RemainingLocation {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      align-items: center;
      .action-btn {
        margin-left: 20px;
      }
    }
  }
  //   表格
  .Table {
    min-height: 450px;
    margin-top: 30px;
    // border: 1px solid gold;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
